import { render, staticRenderFns } from "./ProductViewLogs.vue?vue&type=template&id=4594f96e"
import script from "./ProductViewLogs.vue?vue&type=script&lang=js"
export * from "./ProductViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports